import type {
	FilterDropdownConfigList,
	FilterItem,
	FilterValue,
} from './types';
import { useFilterItems } from './useFilterItems';
import { getSubValueAsArray } from './utils';

interface UseNestedFilterLabelProps {
	getItems?: FilterDropdownConfigList['getItems'];
	getItemsById?: FilterDropdownConfigList['getItemsById'];
	value: FilterValue;
}

export function useNestedFilterLabel({
	getItems,
	getItemsById,
	value,
}: UseNestedFilterLabelProps) {
	const {
		error: hasListItemsError,
		loading: isLoadingListItems,
		items: listItems,
	} = useFilterItems({
		getItems,
		getItemsById,
		value,
		isNested: true,
	});

	const selectedValues: FilterItem[] = [];

	if (hasListItemsError) {
		return 'Error loading filter';
	}
	if (isLoadingListItems) {
		return 'Loading';
	}

	const values = getSubValueAsArray(value);

	selectedValues.push(
		...listItems.filter((item) => values.includes(item.value))
	);

	return selectedValues.map((item) => item.label).join(', ');
}
